.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
}

.toggle-row {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 8px;
  justify-content: space-between;
}

.timer-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.timer-duration {
  max-width: 80px;
}

.timer-duration-invalid input {
  border-color: var(--color-destructive, #ef4444);
}

.timer-direction {
  max-width: 120px;
}

.timer-reference {
  max-width: 180px;
}

.error {
  color: var(--color-destructive, #ef4444);
}

.footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 8px;
}
